var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"close-btn-x p-10 lg_p-20",attrs:{"aria-label":"Close"},on:{"click":function($event){return _vm.$emit('click')}}},[_c('svg-x',{staticClass:"block h-8 w-8 lg_h-12 lg_w-12"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }